export const IMPACT_TRACKER_CHART_ITEM = 'IMPACT_TRACKER_CHART_ITEM'
export const IMPACT_TRACKER_CHART_LEGEND_BUTTON =
  'IMPACT_TRACKER_CHART_LEGEND_BUTTON'

export const IMPACT_TRACKER_HELP_URL_EN =
  'https://help.everphone.app/en/collections/3741648-sustainability'

export const IMPACT_TRACKER_HELP_URL_DE =
  'https://help.everphone.app/de/collections/3741648-nachhaltigkeit'
